import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-pressed"];
const _hoisted_2 = { class: "df-preset-btn__amount" };
const _hoisted_3 = {
    key: 0,
    class: "df-preset-btn__desc"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'PresetAmountButton',
    props: {
        label: {},
        description: {},
        selected: { type: Boolean }
    },
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                type: "button",
                class: _normalizeClass(["df-preset-btn", { 'is-selected': __props.selected }]),
                "aria-pressed": __props.selected
            }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1 /* TEXT */),
                (__props.description)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.description), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
